module.exports = __webpack_public_path__ + "img/149.2b1069d5.jpg";